import { apiRequest } from "./client";

export type UserRole = "NORMAL_USER" | "REVIEWER" | "ADMIN";
export type UserStatus = "ACTIVE" | "DISABLED";

export interface CurrentUser {
  id: string;
  username: string;
  name: string;
  avatar_url: string | null;
  avatar_text: string;
  role: UserRole;
  status: UserStatus;
  must_change_password: boolean;
  is_core_account: boolean;
  version: number;
}

export interface AgentProfile {
  name: string;
  phone: string | null;
  version: number;
}

export function login(username: string, password: string): Promise<{ user: CurrentUser }> {
  return apiRequest("/api/v1/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
}

export function fetchCurrentUser(signal?: AbortSignal): Promise<CurrentUser> {
  return apiRequest("/api/v1/auth/me", { signal });
}

export function fetchAgentProfile(signal?: AbortSignal): Promise<AgentProfile> {
  return apiRequest("/api/v1/auth/agent-profile", { signal });
}

export function updateAgentProfile(payload: {
  name: string;
  phone: string | null;
  version: number;
}): Promise<AgentProfile> {
  return apiRequest("/api/v1/auth/agent-profile", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function logout(): Promise<void> {
  return apiRequest("/api/v1/auth/logout", { method: "POST" });
}

export function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  return apiRequest("/api/v1/auth/change-password", {
    method: "POST",
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  });
}
